import { makeCloudFunction } from "../makeCloudFunction";
import { Category } from "@functions-types";
import { makeUseCloudFunction } from "../makeUseCloudFunction";

export type { Category };
export const listCategories = makeCloudFunction<void, Category[]>("category", "listCategories");
export const useListCategories = makeUseCloudFunction(listCategories);
